/**
 * @brief Membership 멤버쉽 페이지
 * @details
 * @author hyekyoungKang
 * @date 2024-06-10
 * @version 0.0.1
 */

import React from "react";
import styles from "./Membership.module.scss";
import MembershipCard from "../../components/pagesComponents/membership/MembershipCard";
import SubBanner from "../../components/common/subBanner/SubBanner";
import MetaTags from "../../components/meta/MetaTag";

const data = [
    {
        title: "비상주 사무실",
        subTitle:
            "사업자를 위한 비상주 주소지를 제공합니다.",
    },
    {
        title: "라운지 패스",
        subTitle:
            "라운지 시설을 자유롭게 사용할 수 있으며 무선 wifi 및 커피가 무료로 제공됩니다. 단, 사업장의 주소는 사용할 수 없습니다.",
    },
    {
        title: "독립형 상주 사무실",
        subTitle:
            "1인실, 2인실, 3인실, 4인실, 5인실, 8인실로 구성되어 있으며 독립된 사무실을 고정적으로 사용할 수 있습니다. 라운지를 포함한 모든 시설 또한 자유롭게 이용 가능합니다. 계약 및 비용에 관한 부분은 개별 상담을 통해 문의하실 수 있습니다.",
    },
    {
        title: "기타 공간 사용 안내",
    },
];

const Membership = () => {
    return (
        <>
            <MetaTags title="멤버십 | 스마트워크" />
            <div className={styles.container}>
                <SubBanner title={"멤버십"} hasMarginBottom={"16rem"} />
                <section className={styles.section}>
                    {data.map((item) => {
                        return (
                            <React.Fragment key={item.title}>
                                <MembershipCard
                                    cardTitle={item.title}
                                    cardSubTitle={item.subTitle}
                                    item={item}
                                />
                            </React.Fragment>
                        );
                    })}
                </section>
                {/* <div className={styles.mainImg}></div> */}
            </div>
        </>
    );
};

export default Membership;
